import { window } from './globals';

interface ReactNativeWindow {
  postMessage: (message: string) => {};
}

export const getReactNativeWebView = (): ReactNativeWindow | undefined => {
  return (window as any)?.ReactNativeWebView;
};

export const sendMessage = (message: string) => {
  return getReactNativeWebView()?.postMessage(message);
};

export const hideSurveyCloseButton = () => {
  return sendMessage('disable-closing-survey');
};

export const showSurveyCloseButton = () => {
  return sendMessage('enable-closing-survey');
};
